import {
  ABOUT_LINK_EN,
  ABOUT_LINK_SV,
  ACCESSIBILITY_DECLARATION_LINK_EN,
  ACCESSIBILITY_DECLARATION_LINK_NO,
  ACCESSIBILITY_DECLARATION_LINK_SV,
  CUSTOMER_SERVICE_EMAIL,
  PRIVACY_LINK_SV,
  TERMS_LINK_SV,
} from '../../constants';

type AboutLink = {
  sv?: string | undefined;
  en?: string | undefined;
  no?: string | undefined;
};

export const aboutLinks = {
  about: {
    en: ABOUT_LINK_EN,
    sv: ABOUT_LINK_SV,
  },
  privacyPolicy: {
    sv: PRIVACY_LINK_SV,
  },
  termsOfUse: {
    sv: TERMS_LINK_SV,
  },
  accessibilityDeclaration: {
    en: ACCESSIBILITY_DECLARATION_LINK_EN,
    sv: ACCESSIBILITY_DECLARATION_LINK_SV,
    no: ACCESSIBILITY_DECLARATION_LINK_NO,
  },
  customerServiceEmail: {
    en: CUSTOMER_SERVICE_EMAIL,
  },
} satisfies Record<string, AboutLink>;

export const getLink = (link: AboutLink, currentLanguage: string) => {
  const maybeLink = link[currentLanguage as keyof AboutLink];
  if (maybeLink) {
    return maybeLink;
  }
  if (link['en']) {
    return link['en'];
  }
  return Object.values(link)?.[0] || '';
};
